import axios from "axios";

export default axios.create({
  baseURL: `https://semikolan-backend.lordblackwood.repl.co/`,
});
